module.exports = __webpack_public_path__ + "media/assets/images/category/Anniversary@2x-97b6523dae31fcb193d2155068ecee17.png";